import React, { useEffect, useLayoutEffect } from 'react';
import { connect, Provider } from 'react-redux';
import * as actions from '../../../../redux/user/actions.user';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import ConnectGithubAccountForm from '../../../containers/ConnectGithubAccountForm';
import PopupWrapper from '../../../components/Popup/PopupWrapper';
import PopupBody from '../../../components/Popup/PopupBody';
import PopupHeader from '../../../components/Popup/PopupHeader';
import { getNeededStartsFromGitHubPlan } from '../../../../services/mini/getNeededStartsFromGitHubPlan';
import { getEncGitHubToken } from '../../../../services/mini/gitHubToken';
import store from '../../../../store';
import { GitHubStars } from '../GitHubStars';
import PopupButtons from '../../../components/Popup/PopupButtons';
import PopupButton from '../../../components/Popup/PopupButton';
import SwitchGitHubPromoPlanPopupManager from '../../../../services/SwitchGitHubPromoPlanPopupManager';
import withClickOutsideOnOverlay from '../../../../hoc/withClickOutsideOnOverlay';

function SwitchToGitHubPromoPlanPopup({
    email,
    plan,
    githubLogin,
    numOfStars,
    changePlan,
    onClose
}) {

    useEffect(() => {
        SwitchGitHubPromoPlanPopupManager.markOpenForFuture(email);
    }, [email]);

    useLayoutEffect(() => {
        return () => {
            SwitchGitHubPromoPlanPopupManager.markClosedForFuture(email);
        };
    }, [email]);

    const githubStars = getNeededStartsFromGitHubPlan(plan);
    const githubConnected = githubLogin && getEncGitHubToken();
    const hasEnoughStars = githubStars <= numOfStars;
    const canProceed = (githubConnected && hasEnoughStars);

    return <Provider store={store}>
        <PopupWrapper className="switch-to-gh-plan-popup">
            <PopupHeader
                title={`${plan.name} Plan`}
                onCancel={onClose} />
            <PopupBody>
                <div>
                    <ul>
                        <li className={githubConnected ? 'done' : ''}>
                            Link your GitHub account with your Alan account.
                        </li>
                        <div className={`switch-to-gh-plan-popup__gh-btn-wrapper ${githubConnected && 'disabled'}`}>
                            <ConnectGithubAccountForm
                                githubLogin={githubLogin}
                                title="Connect" />
                        </div>
                        <li className={(githubConnected && hasEnoughStars) ? 'done' : ''}>
                            Star at least {githubStars}&nbsp; <a href="http://github.com/alan-ai" target="_blank" rel="noopener noreferrer">Alan repositories</a>.
                        </li>
                        <GitHubStars githubStars={githubStars} numOfStars={numOfStars} />
                    </ul>
                </div>
                <PopupButtons>
                    <PopupButton
                        title="Complete all steps to switch to the plan"
                        className={`${!canProceed ? 'disabled-with-cursor' : ''}`}
                        label="Continue"
                        action={canProceed ? changePlan : undefined} />
                </PopupButtons>
            </PopupBody>
        </PopupWrapper>
    </Provider>;
}

function mapStateToProps({ user }, ownProps) {
    return {
        email: user.email,
        githubLogin: user.githubLogin,
        numOfStars: user.numOfStars,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getGithubPromoInfo: (param) => asyncDispatch(actions.getGithubPromoInfo, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withClickOutsideOnOverlay(SwitchToGitHubPromoPlanPopup));